export default "/dist/files/applaudir-plein-stroke.235122e8693280a721b4763a55e5f646.svg";